/**
 * SVG Icon collection
 */
import SVGContrastIcon from "./SVGContrastIcon";
import SVGContrast2Icon from "./SVGContrast2Icon";
import SVGDownTriangleIcon from "./SVGDownTriangleIcon";
import SVGFullscreenIcon from "./SVGFullscreenIcon";
import SVGLayerStackIcon from "./SVGLayerStackIcon";
import SVGLayoutIcon from "./SVGLayoutIcon";
import SVGLayoutTemplateIcon from "./SVGLayoutTemplateIcon";
import SVGMeasureIcon from "./SVGMeasureIcon";
import SVGMeasurementToolIcon from "./SVGMeasurementToolIcon";
import SVGOpenAddFolderIcon from "./SVGOpenAddFolderIcon";
import SVGPanIcon from "./SVGPanIcon";
import SVGPan2Icon from "./SVGPan2Icon";
import SVGSeriesIcon from "./SVGSeriesIcon";
import SVGUserIcon from "./SVGUserIcon";
import SVGZoomIcon from "./SVGZoomIcon";
import SVGZoom2Icon from "./SVGZoom2Icon";
import SVGWarningIcon from "./SVGWarningIcon";
import SVGToggleDicomTagIcon from "./SVGToggleDicomTagIcon";
import SVGInfoIcon from "./SVGInfoIcon";
import SVGSettingIcon from "./SVGSettingIcon";
import SVGQuitIcon from "./SVGQuitIcon";
import SVGAnalysisIcon from "./SVGAnalysisIcon";
import SVGThumbIcon from "./SVGThumbIcon";
import SVGDownloadIcon from "./SVGDownloadIcon";
import SVGUploadIcon from "./SVGUploadIcon";
import SVGTextIcon from "./SVGTextIcon";

import SVGVisibleIcon from "./SVGVisibleIcon";
import SVGPan2ActiveIcon from "./SVGPan2ActiveIcon";
import SVGZoom2ActiveIcon from "./SVGZoom2ActiveIcon";
import SVGContrast2ActiveIcon from "./SVGContrast2ActiveIcon";
import SVGTextActiveIcon from "./SVGTextActiveIcon";

import SVGUnvisibleIcon from "./SVGUnvisibleIcon";
import SVGSmallInfoIcon from "./SVGSmallInfoIcon";
/**
 * CSS Icon Collection
 */
import SVGCheckmarkIcon from "./SVGCheckmarkIcon";

import SVGUserLoginIcon from "./SVGUserLoginIcon";
import SVGUserPasswordIcon from "./SVGUserPasswordIcon";

import SVGErase2Icon from "./SVGErase2Icon";
import SVGErase2ActiveIcon from "./SVGErase2ActiveIcon";
import SVGErase2ViewIcon from "./SVGErase2ViewIcon";

import SVGPen2Icon from "./SVGPen2Icon";
import SVGPen2ActiveIcon from "./SVGPen2ActiveIcon";
import SVGPen2ViewIcon from "./SVGPen2ViewIcon";

const Icon = {
  SVGContrastIcon,
  SVGDownTriangleIcon,
  SVGFullscreenIcon,
  SVGLayerStackIcon,
  SVGLayoutIcon,
  SVGLayoutTemplateIcon,
  SVGMeasureIcon,
  SVGMeasurementToolIcon,
  SVGOpenAddFolderIcon,
  SVGPanIcon,
  SVGSeriesIcon,
  SVGUserIcon,
  SVGZoomIcon,
  SVGWarningIcon,
  SVGToggleDicomTagIcon,
  SVGInfoIcon,
  SVGCheckmarkIcon,
  SVGSettingIcon,
  SVGQuitIcon,
  SVGAnalysisIcon,
  SVGThumbIcon,
  SVGDownloadIcon,
  SVGUploadIcon,
  SVGTextIcon,
  SVGPan2Icon,
  SVGPan2ActiveIcon,
  SVGZoom2ActiveIcon,
  SVGContrast2ActiveIcon,
  SVGTextActiveIcon,
  SVGZoom2Icon,
  SVGContrast2Icon,
  SVGVisibleIcon,
  SVGUnvisibleIcon,
  SVGSmallInfoIcon,
  SVGUserLoginIcon,
  SVGUserPasswordIcon,
  
  SVGErase2Icon,
  SVGErase2ActiveIcon,
  SVGErase2ViewIcon,
  SVGPen2Icon,
  SVGPen2ActiveIcon,
  SVGPen2ViewIcon
};

export default Icon;
